document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.acc__item');
    const headers = document.querySelectorAll('.acc-toggle');
    const contents = document.querySelectorAll('.acc-content');

    headers.forEach((header, index) => {
      header.addEventListener('click', () => {
        contents.forEach((content, contentIndex) => {
          if (index !== contentIndex) {
            content.style.maxHeight = null;
            accordionItems[contentIndex].classList.remove('active');
          }
        });
        if (contents[index].style.maxHeight) {
          contents[index].style.maxHeight = null;
          accordionItems[index].classList.remove('active');
        } else {
          contents[index].style.maxHeight = contents[index].scrollHeight + 'px';
          accordionItems[index].classList.add('active');
        }
      });
    });
  
  var screenWidth = window.innerWidth;
  if (screenWidth <= 650) {
    var dropdownTitles = document.querySelectorAll(".hw--page-accordion .hw-title");

    function toggleFaqState(element) {
      element.classList.toggle("hw--faq-open");
      element.classList.toggle("hw--faq-close");
      element.querySelector(".hw--fa-angle-down").classList.toggle("hw--fa-angle-up");
    }

    dropdownTitles.forEach(function (title) {
      title.addEventListener("click", function () {
        var accordion2col = this.nextElementSibling;
        if (accordion2col.style.display === "grid") {
          accordion2col.style.display = "none";
        } else {
          accordion2col.style.display = "grid";
        }
        toggleFaqState(this);
      });
    });

    var accordion2colElements = document.querySelectorAll(".hw--page-accordion .hw__accordion-2col");
    accordion2colElements.forEach(function (element) {
      element.style.display = "none";
      element.previousElementSibling.classList.add("hw--faq-close");
    });
  } else {
    var accordion2colElements = document.querySelectorAll(".hw--page-accordion .hw__accordion-2col");
    accordion2colElements.forEach(function (element) {
      element.style.display = "grid";
    });
  }
});